import { useState, useEffect, useRef, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components"
import axios from "axios";
import {
  Modal,
  Table,
  Button,
  Input,
  Form,
  Row,
  Col,
  Layout,
  Select,
  Checkbox,
  Space,
  Spin,
  Tabs,
  InputNumber,
  Divider
} from "antd";
import {
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  CloseOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import createImagePromptGPT from "./controller/createImagePromptGPT";

const backend = process.env.REACT_APP_BACKEND;
const start = process.env.REACT_APP_VARIABLE_START
const end = process.env.REACT_APP_VARIABLE_END
const meaningPrompt = process.env.REACT_APP_MEANING_PROMPT
const backgroundPrompt = process.env.REACT_APP_BACKGROUND_PROMPT

const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
`;

const SentenceImageRightFinalPromptTab = forwardRef((
  {
    promptData,
    promptDataChangeHandler,
    promptDataChangeHandlerAll,
    promptDataChangeHandlerAll2,
    getDataSource,
    sentenceData,
    imageConfig,
    reRenderHandler,
    loadingHandler
  },
  promptRef,
) => {
  const navigate = useNavigate();
  // const formRef = useRef()
  const [rightBox, setRightBox] = useState([false, {}])
  const [statements, setStatements] = useState([false, null, {}])
  const [finalPromptSentence, setFinalPromptSentence] = useState("")
  const [isVariableCondition, SetIsVariableCondition] = useState(false)
  const [compareCondition, setCompareCondition] = useState(true)
  const [createMeaningPromptLoading, setCreateMeaningPromptLoading] = useState(false)
  const [createBackgroundPromptLoading, setCreateBackgroundPromptLoading] = useState(false)
  // const [sourceData, setSourceData] = useState([])
  // const [sourceDataOrigin, setSourceDataOrigin] = useState([])

  // const getDataSource = (data) => {
  //   const source = data.data.data.map(el=>{
  //     const text = el.statement_text

  //     let variableArray = []
  //     let textArray = []

  //     const variableF = (text) =>{
  //       // const text = String(textValue)
  //       if(text === null || text === undefined) return
  //       const a = text.indexOf("{")
  //       const b = text.indexOf("}")
  //       if(a === -1 || b === -1) {
  //         textArray.push(text)
  //         return
  //       }
  //       const variableText = text.substring(a+1,b) // 변수
  //       const preText = text.slice(0,a) // 변수 전의 텍스트
  //       variableArray.push(variableText)
  //       textArray.push(preText)
  //       const nextText = text.slice(b+1) // 변수 후의 나머지 텍스트
  //       variableF(nextText)
  //     }

  //     variableF(text)

  //     el.statement_variable_array = variableArray
  //     el.statement_text_array = textArray
  //     el.variableArray = el.variable_default_value?.split(",").map(el=>el.trim()) || []
  //     el.prompt_text = el.statement_variable_array.length === 0 ? (el.statement_text && el.statement_text) : promptFuntion(el)
  //     return el
  //   })
  //   console.log(source)
  //   setSourceData(source)
  //   setSourceDataOrigin(source)
  // }

  // const promptFuntion = (el) => {
  //   let prompt = ""
  //   for(let i=0; i<=el.statement_variable_array.length; i++){
  //     prompt = prompt + el.statement_text_array[i] + (el.variableArray[i] || "")
  //   }
  //   return prompt
  // }

  const columns = [
    {
      title: "프롬프트 문장",
      dataIndex: "statement_text",
      width: 200,
      // render: (_,record)=>_ ? <div>{(_/record.total*100).toFixed(1)+"%"}</div> : null
    },
    {
      title: "선택",
      dataIndex: "",
      width: 50,
      render: (_)=><a onClick={()=>choiceStatementHandler(_)}>선택</a>
    },
  ]

  const getStructure = (promptData) => {
    return (
      <Space direction="vertical" size="small" style={{ width: "100%", marginBottom:20 }}>
        {promptData.map((el,id)=>
          (el.ContentSettingDALLEPrompt_id === 1 || el.ContentSettingDALLEPrompt_id === 2)
          ?
          <Spin key={id} spinning={el.ContentSettingDALLEPrompt_id === 1 ? createMeaningPromptLoading : createBackgroundPromptLoading}>
            <Space direction="vertical" style={{width:"100%"}}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Checkbox 
                  checked={el.useYn === "Y" ? true : false}
                  onChange={()=>{promptUseYnHandler(id)}}
                >
                  {el.prompt_name}
                </Checkbox>
                <Button size="small" onClick={el.ContentSettingDALLEPrompt_id === 1 ? ()=>createMeaningPrompt(id) : ()=>createBackgroundPrompt(id)}>프롬프트 생성</Button>
              </div>
              {
                el.statement_variable_array.length && el.useYn === "Y"
                ?
                el.statement_variable_array.map((ele,idx)=>
                <Space key={idx} direction="vertical" style={{width:"100%"}}>
                    <div style={{ display: "flex", justifyContent: "left", marginLeft:40 }}>
                      <Checkbox 
                        checked={el.statement_variable_useyn[idx] === "Y" ? true : false}
                        onChange={()=>{statementUseYnHandler(id, idx)}}
                      >
                        {ele}
                      </Checkbox>
                    </div>
                    <div style={{marginLeft:40}}>
                      <Input size="small" value={el.variableArray[idx]} onChange={(e)=>statementVariableChangeHandler(id,idx,e)}></Input>
                    </div>
                  </Space>
                )
                : null
              }
              <Input.TextArea 
                autoSize
                value={el.statement_text} 
                disabled = {el.useYn === "Y" ? false : true}
                onChange={(e)=>statementTextChangeHandler(id, e)}
                onBlur={(e)=>statementTextBlurHandler(id,e)}>
              </Input.TextArea>
              {
                el.useYn === "Y"
                ? <Input.TextArea
                  autoSize
                  disabled
                  style={{color:"black"}}
                  value={el.prompt_text}>
                </Input.TextArea>
                : null
              }
              <div style={{ display: "flex", justifyContent: "left" }}>
                <Button size="small" style={{ marginRight: 10 }} onClick={()=>upHandler(el,id)}>위로</Button>
                <Button size="small" onClick={()=>downHandler(el,id)}>아래로</Button>
              </div>
              <Divider />
            </Space>
          </Spin>
          :
          <Space key={id} direction="vertical" style={{width:"100%"}}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Checkbox 
                checked={el.useYn === "Y" ? true : false}
                onChange={()=>{promptUseYnHandler(id)}}
              >
                {el.prompt_name}
              </Checkbox>
              <Button size="small" onClick={()=>sentenceChangeHandler(id,el.ContentSettingDALLEPrompt_id)}>문장변경</Button>
            </div>
            {
              el.statement_variable_array.length && el.useYn === "Y"
              ?
              el.statement_variable_array.map((ele,idx)=>
              <Space key={idx} direction="vertical" style={{width:"100%"}}>
                  <div style={{ display: "flex", justifyContent: "left", marginLeft:40 }}>
                    <Checkbox 
                      checked={el.statement_variable_useyn[idx] === "Y" ? true : false}
                      onChange={()=>{statementUseYnHandler(id, idx)}}
                    >
                      {ele}
                    </Checkbox>
                  </div>
                  <div style={{marginLeft:40}}>
                    <Input size="small" value={el.variableArray[idx]} onChange={(e)=>statementVariableChangeHandler(id,idx,e)}></Input>
                  </div>
                </Space>
              )
              : null
            }
            <Input.TextArea 
              autoSize 
              value={el.statement_text} 
              disabled = {el.useYn === "Y" ? false : true}
              onChange={(e)=>statementTextChangeHandler(id, e)}
              onBlur={(e)=>statementTextBlurHandler(id,e)}>
            </Input.TextArea>
            {
              el.useYn === "Y"
              ? <Input.TextArea
                autoSize
                disabled
                style={{color:"black"}}
                value={el.prompt_text}>
              </Input.TextArea>
              : null
            }
            <div style={{ display: "flex", justifyContent: "left" }}>
              <Button size="small" style={{ marginRight: 10 }} onClick={()=>upHandler(el,id)}>위로</Button>
              <Button size="small" onClick={()=>downHandler(el,id)}>아래로</Button>
            </div>
            <Divider />
          </Space>
        )}
      </Space>
    )
  }

  const sentenceChangeHandler = (num,id) => {
    axios
      .get(`${backend}/contents/content_sentence/image_ai/gpt/statements/${id}`)
      .then(res=>{
        setStatements([true,num,res.data.data])
      })
      .catch(err=>{
        console.log(err);
        if(err.response && err.response.status===401) {
          navigate("/auth")
        }
      })
    
  }

  const choiceStatementHandler = (_) => {
    const newData = promptData.slice(0)
    const num = statements[1]
    newData[num].statement_text = _.statement_text
    newData[num].variable_default_value = _.variable_default_value
    promptDataChangeHandlerAll2(newData, num)
    setStatements([false,null,{}])
  }

  const statementVariableChangeHandler = (id,idx,e) => {
    const value = e.target.value
    const newData = promptData.slice(0)
    newData[id].variableArray[idx] = value
    promptDataChangeHandler(newData)
  }

  const statementTextChangeHandler = (id, e) => {
    const value = e.target.value
    const newData = promptData.slice(0)
    newData[id].statement_text = value
    promptDataChangeHandler(newData)
  }
  const statementTextBlurHandler = (id, e) => {
    const value = e.target.value
    const newData = promptData.slice(0)
    newData[id].statement_text = value
    promptDataChangeHandlerAll(newData)
  }

  const promptUseYnHandler = (id)=>{
    const newData = promptData.slice(0)
    newData[id].useYn = newData[id].useYn === "Y" ? "N" : "Y"
    promptDataChangeHandler(newData)
  }
  const statementUseYnHandler = (id,idx)=>{
    const newData = promptData.slice(0)
    newData[id].statement_variable_useyn[idx]= newData[id].statement_variable_useyn[idx] === "Y" ? "N" : "Y"
    promptDataChangeHandler(newData)
  }

  const upHandler = (el,id) =>{
        const newData = promptData.slice(0)
    if(id === 0) {
      return
    }

    newData[id].order = newData[id].order -1
    newData[id-1].order = newData[id-1].order +1

    const orderdData = newData.sort((a,b)=>a.order-b.order)

    promptDataChangeHandler(orderdData)
  }
  
  const downHandler = (el,id) => {
        const newData = promptData.slice(0)
    if(id === newData.length -1) {
      return
    }
    
    newData[id].order = newData[id].order +1
    newData[id+1].order = newData[id+1].order -1
    const orderdData = newData.sort((a,b)=>a.order-b.order)
    
    promptDataChangeHandler(orderdData)
  }

  const finalPromptSentenceHandler = () => {
    if(promptData.length) {
      const promptSentence = promptData.reduce((acc,cur)=>{
        if(!cur.prompt_text || cur.useYn === "N") return acc
        if(acc === "") {
          acc += cur.prompt_text
        } else {
          acc += "\n"+cur.prompt_text
        }
        return acc
      },"")
      promptRef.current.setFieldValue("prompt_text", promptSentence)
      setFinalPromptSentence(promptSentence)
    }
  }

  const createMeaningPrompt = (id) => {
    const prompt = meaningPrompt.replace("{}",sentenceData.sentence_text)
    // const prompt = `Create a prompt for Dall E 3 to generate an image describing the sentence "${sentenceData.sentence_text}". Your prompt should be written to help viewers better understand the meaning of the sentence. Make sure to include the sentence in your prompt.`
    // setCreateMeaningPromptLoading(true)
    loadingHandler(true)
    createImagePromptGPT(prompt, imageConfig.gpt_model)
    .then(newPrompt=>{
      let onlyPrompt = newPrompt
      if(newPrompt[0] === `"`) {
        onlyPrompt = newPrompt.slice(1,-1)
      }

      const newData = promptData.slice(0)
      newData[id].statement_text = onlyPrompt
      promptDataChangeHandlerAll(newData)
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title:"에러",
        okText:"확인",
        content:"AI 에러가 발생해서 문장을 생성하지 못했습니다."
      })
    })
    .finally(()=>{
      // setCreateMeaningPromptLoading(false)
      loadingHandler(false)
    })
  }

  const createBackgroundPrompt = (id) => {
    const prompt = backgroundPrompt.replace("{}",sentenceData.sentence_text)
    // const prompt = `Create a prompt for Dall E 3 to generate a background image that helps viewers understand the meaning of "${sentenceData.sentence_text}". Make sure to include the sentence in your prompt.`
    // setCreateBackgroundPromptLoading(true)
    loadingHandler(true)
    createImagePromptGPT(prompt, imageConfig.gpt_model)
    .then(newPrompt=>{
      let onlyPrompt = newPrompt
      if(newPrompt[0] === `"`) {
        onlyPrompt = newPrompt.slice(1,-1)
      }

      const newData = promptData.slice(0)
      newData[id].statement_text = onlyPrompt
      promptDataChangeHandlerAll(newData)
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title:"에러",
        okText:"확인",
        content:"AI 에러가 발생해서 문장을 생성하지 못했습니다."
      })
    })
    .finally(()=>{
      // setCreateBackgroundPromptLoading(false)
      loadingHandler(false)
    })
  }

  useEffect(()=>{
    const curFinalPromptSentence = promptRef.current.getFieldValue("prompt_text") || ""
    const a = curFinalPromptSentence.indexOf(start)
    let b = -1

    // 어느 위치의 변수가 빠졌는지 확인하는 재귀함수
    const bFunction = (text) => {
      if(text.indexOf(end) === -1) return
      if(text.indexOf(end) > a) {
        b=text.indexOf(end)
        return
      }
      const subText = text.replace(end,"a")
      bFunction(subText)
    }
    bFunction(curFinalPromptSentence)

    if(a === -1 || b === -1) {
      SetIsVariableCondition(true)
    } else {
      SetIsVariableCondition(false)
    }

    const promptSentence = promptData.reduce((acc,cur)=>{
      if(!cur.prompt_text || cur.useYn === "N") return acc
      if(acc === "") {
        acc += cur.prompt_text
      } else {
        acc += "\n"+cur.prompt_text
      }
      return acc
    },"")
    
    if(JSON.stringify(curFinalPromptSentence) === JSON.stringify(promptSentence)) {
      setCompareCondition(true)
    } else {
      setCompareCondition(false)
    }
},[promptData,finalPromptSentence])

useEffect(()=>{
  promptRef.current.resetFields()
},[sentenceData.id])


  return (
    <Form
    ref={promptRef}
    >
      <Space direction="vertical" style={{width:"100%"}}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <span>최종 프롬프트 문장</span>
            <span style={{color:"red"}}>
              {
                compareCondition && isVariableCondition ? ""
                : compareCondition && !isVariableCondition ? "(변수가 포함되어 있음)"
                : !compareCondition && isVariableCondition ? "(위 조건과 상이함)"
                : "(위 조건과 상이함, 변수가 포함되어 있음)"
              }
            </span>
          </div>
          <Button size="small" onClick={finalPromptSentenceHandler}>문장 다시 생성</Button>
        </div>
        <Form.Item name="prompt_text">
          <Input.TextArea
            autoSize
            value={finalPromptSentence}
            onChange={(e)=>setFinalPromptSentence(e.target.value)}
          />
        </Form.Item>
      </Space>
      {getStructure(promptData)}

      <Modal
        destroyOnClose={true}
        width={"50%"}
        open={statements[0]}
        title="프롬프트 문장"
        onCancel={()=>{setStatements([false,{}])}}
        footer={null}
        
      >
        <div style={{background:"red", height:"400px"}}>
          <StyledTable
            className="pageTable"
            columns={columns}
            rowKey="id"
            dataSource={statements[2]}
            // loading={loading}
            pagination={false}
            scroll={{ x:100, y:"100%"}}
          />
        </div>
      </Modal>
    </Form>
  )
});
export default SentenceImageRightFinalPromptTab;